export default "__VITE_ASSET__72e2d017__"